import SOCIAL_CARD_OVERRIDES from "@/data/socialCardOverrides.json";

export const INTEGRATED_SOCIAL_ORIGIN = "https://integrated.social";

/**
 * Purpose-built 1200×630 images for public tools whose interactive UI does not
 * otherwise have a single hero image suitable for social crawlers.
 */
export const TOOL_SOCIAL_PREVIEWS = {
  tokenCalculator: `${INTEGRATED_SOCIAL_ORIGIN}/media/ai-token-calculator-social-preview-1200x630_21c4ab8f.jpg`,
  promptImprover: `${INTEGRATED_SOCIAL_ORIGIN}/media/ai-prompt-improver-social-preview-1200x630_9844f460.jpg`,
  utmBuilder: `${INTEGRATED_SOCIAL_ORIGIN}/media/utm-builder-social-preview-1200x630_2aea83ce.jpg`,
} as const;

/**
 * Public crawlers require an absolute image URL. An explicit `socialImage` is
 * an intentional JPEG/PNG share crop of the article hero; otherwise, use the
 * article's actual visible hero asset. The public map below is the single
 * source of truth for legacy files whose extension does not match the MIME
 * delivered by storage: it points only social crawlers to a durable JPEG,
 * without changing the visible on-page hero.
 */
export { SOCIAL_CARD_OVERRIDES };

export function resolveSocialPreviewImage(image?: string | null): string | undefined {
  if (!image) return undefined;
  const absolute = /^https?:\/\//i.test(image)
    ? image
    : image.startsWith("/")
      ? `${INTEGRATED_SOCIAL_ORIGIN}${image}`
      : image;
  const override = SOCIAL_CARD_OVERRIDES[absolute as keyof typeof SOCIAL_CARD_OVERRIDES];
  return override ? `${INTEGRATED_SOCIAL_ORIGIN}${override}` : absolute;
}
